// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4t3i1osq{height:100%}\n._c71lxy5q{max-height:var(--ds-space-400,2pc)}", ""]);
// Exports
module.exports = exports;
